import type { AxiosInstance } from "axios";
import { APP_VERSION_HEADER } from "./appVersion";

const registered = new WeakSet<AxiosInstance>();

/**
 * SA-1416: toda request declara a versão do build; o backend grava no New
 * Relic e a gente sabe quem ainda está numa versão antiga. Idempotente por
 * instância (StrictMode e remontagens chamam de novo).
 */
export function registerAppVersionHeader(
  instance: AxiosInstance,
  version: string
) {
  if (registered.has(instance)) return;
  registered.add(instance);
  instance.interceptors.request.use((config) => {
    config.headers.set(APP_VERSION_HEADER, version);
    return config;
  });
}
